import { API } from '@/config';

import {
  FILL_LIST,
} from './mutations-types';

export default {
  async getStatusList({ commit }) {
    try {
      const { records } = (await API.get('/agent/status/getList')).data.data;
      commit(FILL_LIST, { records });
    } catch (err) {
      console.log(err);
    }
  },
};
